import { api } from "../api";
import type { PaginatedResponse, VenueCreate, VenueItem } from "../../types/domain";

export const venueService = {
  getAll: (params?: { center_id?: string; skip?: number; limit?: number }) => {
    const query = new URLSearchParams();
    if (params?.center_id) query.set("center_id", params.center_id);
    if (params?.skip !== undefined) query.set("skip", String(params.skip));
    if (params?.limit !== undefined) query.set("limit", String(params.limit));
    const qs = query.toString();
    return api.get<PaginatedResponse<VenueItem>>(`/venues${qs ? `?${qs}` : ""}`);
  },

  create: (data: VenueCreate) => api.post<VenueItem>("/venues", data),
};
